import { computed, ref, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { request } from '../utils.js'
import useLoading from './loading.js'

function option(key, defaultValue = null) {
  return window.sessionStorage?.getItem(`kas_options_${key}`) ?? defaultValue
}

function remember(key, value) {
  window.sessionStorage?.setItem(`kas_options_${key}`, value)
}

export default function useOptions() {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  if (urlParams.get('city')) {
    window.defaultCity = urlParams.get('city')
  }

  const store = useStore()
  const { isLoading, start, stop } = useLoading()

  function isFavorite(payload) {
    return store.getters.isFavorite(payload)
  }

  function toggleFavorite(payload) {
    store.commit('toggleFavorite', payload)
  }

  const city = ref(
    window.defaultCity ? window.defaultCity : option('city', 'Akaa')
  )

  const maxPrice = ref(
    Number(option('max_price', 1500))
  )

  const buildingTypes = ref(
    JSON.parse(option('building_types', '[]'))
  )

  const numberOfRooms = ref(
    JSON.parse(option('number_of_rooms', '[]'))
  )

  const options = ref(null)

  async function fetchOptions() {
    start('options')
    options.value = await request('/options', {})
    stop('options')
  }

  watch(city, value => remember('city', value))
  watch(maxPrice, value => remember('max_price', value))
  watch(buildingTypes, value => remember('building_types', JSON.stringify(value)))
  watch(numberOfRooms, value => remember('number_of_rooms', JSON.stringify(value)))

  onMounted(async () => await fetchOptions())

  return {
    city,
    maxPrice,
    buildingTypes,
    numberOfRooms,
    options,
    optionsIsLoading: computed(() => isLoading('options')),
    toggleFavorite,
    isFavorite,
  }
}
